import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ErrorReportingService } from './error-reporting.service';

/**
 * Interceptor global de ERROS HTTP (Fase 2 — Erros MVP; feedback visual removido).
 *
 * - 5xx: reporta ao POST /v1/errors/ingest (payload sanitizado). A captura é
 *   SILENCIOSA — qualquer feedback visual (dialog/toast) foi removido por
 *   decisão do usuário.
 * - NÃO reporta 4xx (erro de negócio/validação — sem bug de sistema).
 * - NÃO reporta a PRÓPRIA chamada de /errors/ingest (anti-loop, obrigatório).
 * - status 0 (rede/offline): NADA — nem report, nem toast (regra preservada:
 *   rede/offline não é bug de sistema a ser ingerido).
 *
 * 401/403 continuam sob responsabilidade do AuthInterceptor (nada duplicado).
 */
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor
{
    constructor(
        private _reporting: ErrorReportingService,
    )
    {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) =>
            {
                if ( error instanceof HttpErrorResponse )
                {
                    // Anti-loop: falhas do próprio ingest nunca são reportadas
                    // (evita loop infinito de report).
                    if ( this._isIngestRequest(req.url) )
                    {
                        return throwError(() => error);
                    }

                    if ( error.status >= 500 && error.status <= 599 )
                    {
                        this._reporting.reportHttpError(error, req);
                    }
                    // status 0 (rede/offline) e 4xx: sem report, sem feedback.
                }

                return throwError(() => error);
            })
        );
    }

    private _isIngestRequest(url: string): boolean
    {
        return !!url && url.includes('/errors/ingest');
    }
}